import React from "react";
import "./Interpretation.css";
import { INTERPRETATION } from "../components/Text";

const options = [
  "red",
  "orange",
  "yellow",
  "green",
  "blue",
  "purple",
  "intersex",
  "she",
  "he",
  "they",
  "other",
  "na",
  "grey",
  "grey_2",
];

const interpretations = {
  red: ["feminine", ", feminine", " and feminine", "feminine"],
  blue: ["masculine", ", masculine", " and masculine", "masculine"],
  orange: [
    "somewhat feminine",
    ", somewhat feminine",
    " and somewhat feminine",
  ],
  yellow: [
    "neither feminine nor masculine",
    ", neither feminine nor masculine",
    " and neither feminine nor masculine",
    "gender neutral",
    ", gender neutral",
    " and gender neutral",
  ],
  green: [
    "somewhat masculine",
    ", somewhat masculine",
    " and somewhat masculine",
  ],
  purple: ["n androgynous", ", androgynous", " and androgynous", "androgynous"],

  intersex: ["n intersex", ", intersex", " and intersex"],
  rainbow: [
    "feminine, gender neutral, masculine and androgynous",
    "feminine, gender neutral, masculine and androgynous",
    "feminine, gender neutral, masculine and androgynous",
    "feminine, gender neutral, masculine and androgynous",
    "feminine, gender neutral, masculine and androgynous",
    "feminine, gender neutral, masculine and androgynous",
  ],
  she: ["she", "/she", "/her", "she/her"],
  he: ["he", "/he", "/him", "he/him"],
  they: ["they", "/they", "/them", "they/them"],
  other: ["other", "/other", "/other", "other"],
  na: [""],

  grey: [
    "polyamorous",
    "polyamorous",
    "polyamorous",
    "polyamorous",
    "polyamorous",
    "polyamorous",
  ],
  grey_2: [""],
};

//1. sense of self 'I am a/n XXX person'
//2. Physical characteristics, representaed as '...with a/n XXX body
//3. Pronouns, 'who uses XXX pronouns'
//4. Emotional attraction then physical attraction '[New sentence] I experience emotional attraction to XXX traits and physical attraction to
// XXX traits. If the emotional/physical attraction traits are the same, they are bunched together.
//5. Polyamory status, as represented as '['New sentence] I am polyamorous.'

const Interpretation = ({ data }) => {
  // Convert the object to an array
  const dataArray = Object.values(data);

  var result = [];

  // converts data into an array of results and their colours
  for (let i = 0; i < dataArray.length; i++) {
    var tempArray = [];
    for (const color of options) {
      if (data[i]["ratherNot"] === true) {
        break;
        //if statement for rainbow?
      } else if (data[i]["colors"]["rainbow"] === true) {
        tempArray.push("rainbow");
        break;
      } else if (data[i]["colors"][color] === true) {
        tempArray.push(color);
      }
    }
    result.push(tempArray);
  }

  //converts the sense of self results into their String interpretations
  let resultStringSelf = "";
  for (let i = 0; i < result[0].length; i++) {
    if (i === 0) {
      resultStringSelf +=
        (interpretations[result[0][i]][0].charAt(0) === "n" &&
        interpretations[result[0][i]][0].charAt(1) === " "
          ? "a"
          : "a ") + interpretations[result[0][i]][0];
    } else if (i > 0 && i + 1 === result[0].length) {
      resultStringSelf += interpretations[result[0][i]][2];
    } else {
      resultStringSelf += interpretations[result[0][i]][1];
    }
  }

  //converts the sense of body results into their String interpretations
  let resultStringBody = "";
  for (let i = 0; i < result[1].length; i++) {
    if (i === 0) {
      resultStringBody +=
        (interpretations[result[1][i]][0].charAt(0) === "n" &&
        interpretations[result[1][i]][0].charAt(1) === " "
          ? "a"
          : "a ") + interpretations[result[1][i]][0];
    } else if (i > 0 && i + 1 === result[0].length) {
      resultStringBody += interpretations[result[1][i]][2];
    } else {
      resultStringBody += interpretations[result[1][i]][1];
    }
  }

  //converts the pronoun results into their String interpretations
  let resultStringPronouns = "";
  if (result[2][0] === "na") {
    resultStringPronouns = "na";
  } else {
    for (let i = 0; i < result[2].length; i++) {
      if (i === 0) {
        if (result[2].length === 1 || result[2].length === 2) {
          resultStringPronouns += interpretations[result[2][i]][3];
        } else {
          resultStringPronouns += interpretations[result[2][i]][0];
        }
      } else if (
        i > 0 &&
        i + 2 === result[2].length &&
        resultStringPronouns !== ""
      ) {
        resultStringPronouns += interpretations[result[2][i]][2];
      } else {
        resultStringPronouns += interpretations[result[2][i]][1];
      }
    }
  }

  //converts the emotional attraction results into their String interpretations
  let resultStringEmotional = "";
  for (let i = 0; i < result[3].length; i++) {
    if (i === 0) {
      resultStringEmotional +=
        result[3][i] === "yellow"
          ? interpretations[result[3][i]][3]
          : interpretations[result[3][i]][3];
    } else if (i > 0 && i + 1 === result[3].length) {
      resultStringEmotional +=
        result[3][i] === "yellow"
          ? interpretations[result[3][i]][5]
          : interpretations[result[3][i]][2];
    } else {
      resultStringEmotional +=
        result[3][i] === "yellow"
          ? interpretations[result[3][i]][4]
          : interpretations[result[3][i]][1];
    }
  }

  //converts the physical attraction results into their String interpretations
  let resultStringPhysical = "";
  for (let i = 0; i < result[4].length; i++) {
    if (i === 0) {
      resultStringPhysical +=
        result[4][i] === "yellow"
          ? interpretations[result[4][i]][3]
          : interpretations[result[4][i]][3];
    } else if (i > 0 && i + 1 === result[4].length) {
      resultStringPhysical +=
        result[4][i] === "yellow"
          ? interpretations[result[4][i]][5]
          : interpretations[result[4][i]][2];
    } else {
      resultStringPhysical +=
        result[4][i] === "yellow"
          ? interpretations[result[4][i]][4]
          : interpretations[result[4][i]][1];
    }
  }

  //converts the polyamorous results into their String interpretations
  let resultStringPolyamorous = "";
  for (let i = 0; i < result[5].length; i++) {
    if (result[5][i] !== "") {
      resultStringPolyamorous += interpretations[result[5][i]][0];
    }
  }
  let resultElementSelf;
  //converting sense of self string into html elements
  if (result[0].length === 6) {
    resultElementSelf = (
      <INTERPRETATION id="self" className="self">
        {"I am a person who experiences all gender identities"}
        {resultStringBody === "" && resultStringPronouns === "" ? ". " : " "}
      </INTERPRETATION>
    );
  } else {
    resultElementSelf = (
      <INTERPRETATION id="self" className="self">
        {"I am " +
          resultStringSelf +
          " person" +
          (resultStringBody === "" && resultStringPronouns === "" ? ". " : " ")}
      </INTERPRETATION>
    );
  }

  //converting sense of body string into html elements
  let resultElementBody = (
    <INTERPRETATION id="body" className="body">
      {(resultStringSelf === "" ? "I am a person with " : "with ") +
        resultStringBody +
        " body" +
        (resultStringPronouns === "" ? ". " : " ")}
    </INTERPRETATION>
  );

  //converting pronouns string into html elements
  //who uses specific pronouns (ask me)
  let resultElementPronouns;
  if (resultStringBody === "" && resultStringSelf === "") {
    if (resultStringPronouns === "na") {
      resultElementPronouns = (
        <INTERPRETATION id="pronouns" className="pronouns">
          {"I do not use pronouns."}
        </INTERPRETATION>
      );
    } else if (resultStringPronouns === "other") {
      resultElementPronouns = (
        <INTERPRETATION id="pronouns" className="pronouns">
          {"I use specific pronouns (ask me). "}
        </INTERPRETATION>
      );
    } else {
      resultElementPronouns = (
        <INTERPRETATION id="pronouns" className="pronouns">
          {"I use " + resultStringPronouns + " pronouns. "}
        </INTERPRETATION>
      );
    }
  } else {
    if (resultStringPronouns === "na") {
      resultElementPronouns = (
        <INTERPRETATION id="pronouns" className="pronouns">
          {"who doesn't use pronouns. "}
        </INTERPRETATION>
      );
    } else if (resultStringPronouns === "other") {
      resultElementPronouns = (
        <INTERPRETATION id="pronouns" className="pronouns">
          {"who uses specific pronouns (ask me). "}
        </INTERPRETATION>
      );
    } else {
      resultElementPronouns = (
        <INTERPRETATION id="pronouns" className="pronouns">
          {"who uses " + resultStringPronouns + " pronouns. "}
        </INTERPRETATION>
      );
    }
  }

  //converting physical/emotional attraction string into html elements
  let resultElementEmotionalAndPhysical;
  if (resultStringPhysical === resultStringEmotional) {
    resultElementEmotionalAndPhysical = (
      <INTERPRETATION
        id="emotionalAndPhysical"
        className="emotionalAndPhysical"
      >
        <INTERPRETATION id="experience" className="experience">
          {"I experience "}
        </INTERPRETATION>
        <INTERPRETATION id="physical" className="physical">
          {"physical "}
        </INTERPRETATION>
        <INTERPRETATION id="experience4" className="experience">
          {"and  "}
        </INTERPRETATION>
        <INTERPRETATION id="emotional" className="emotional">
          {"emotional "}
        </INTERPRETATION>
        <INTERPRETATION id="experience3" className="experience">
          {"attraction to "}
        </INTERPRETATION>
        <INTERPRETATION id="experience2" className="experience">
          {resultStringPhysical + " traits."}
        </INTERPRETATION>
      </INTERPRETATION>
    );
  } else {
    resultElementEmotionalAndPhysical = (
      <INTERPRETATION
        id="emotionalAndPhysical"
        className="emotionalAndPhysical"
      >
        {resultStringEmotional !== "" && (
          <>
            <INTERPRETATION id="experience" className="experience">
              {"I experience "}
            </INTERPRETATION>
            <INTERPRETATION id="emotional" className="emotional">
              {"emotional attraction to " + resultStringEmotional + " traits"}
            </INTERPRETATION>
          </>
        )}
        {
          <INTERPRETATION id="experience2" className="experience">
            {" and"}
          </INTERPRETATION>
        }
        {resultStringPhysical !== "" ? (
          <>
            {" "}
            <INTERPRETATION id="physical" className="physical">
              {resultStringEmotional.trim() !== ""
                ? " physical attraction to " + resultStringPhysical + " traits."
                : "I experience physical attraction to " +
                  resultStringPhysical +
                  " traits."}
            </INTERPRETATION>
          </>
        ) : (
          <INTERPRETATION id="emotional2" className="emotional">
            .
          </INTERPRETATION>
        )}
      </INTERPRETATION>
    );
  }

  //since asexual (attraction to nobody) and polamorous results are both listed as 'grey',
  // we need an extra step to diffrentiate them from each other here.
  if (
    resultStringPhysical === "polyamorous" ||
    resultStringEmotional === "polyamorous"
  ) {
    if (
      resultStringPhysical === "polyamorous" &&
      resultStringEmotional === "polyamorous"
    ) {
      resultElementEmotionalAndPhysical = (
        <>
          <INTERPRETATION id="experience" className="experience">
            {"I don't experience "}
          </INTERPRETATION>
          <INTERPRETATION id="physical" className="physical emotional">
            {"physical "}
          </INTERPRETATION>
          <INTERPRETATION id="experience4" className="experience">
            {"or  "}
          </INTERPRETATION>
          <INTERPRETATION id="emotional" className="emotional physical">
            {"emotional attraction."}
          </INTERPRETATION>
        </>
      );
    } else if (
      resultStringPhysical === "polyamorous" &&
      resultStringEmotional !== "polyamorous"
    ) {
      resultElementEmotionalAndPhysical = (
        <>
          <INTERPRETATION id="physical" className="physical">
            {"I don't experience physical attraction"}
          </INTERPRETATION>
          {resultStringEmotional === "" ? (
            <INTERPRETATION id="physical" className="physical">
              .
            </INTERPRETATION>
          ) : (
            <>
              <INTERPRETATION id="emotional" className="emotional">
                {", but I experience emotional attraction to " +
                  resultStringEmotional +
                  " traits."}
              </INTERPRETATION>
            </>
          )}
        </>
      );
    } else if (
      resultStringPhysical !== "polyamorous" &&
      resultStringEmotional === "polyamorous"
    ) {
      resultElementEmotionalAndPhysical = (
        <>
          <INTERPRETATION id="emotional" className="emotional">
            {"I don't experience emotional attraction"}
          </INTERPRETATION>
          {resultStringPhysical === "" ? (
            <INTERPRETATION id="emotional" className="emotional">
              .
            </INTERPRETATION>
          ) : (
            <>
              <INTERPRETATION id="physical" className="physical">
                {", but I experience physical attraction to " +
                  resultStringPhysical +
                  " traits."}
              </INTERPRETATION>
            </>
          )}
        </>
      );
    }
  }

  //converting polyamorous string into html elements
  let resultElementPolyamorous = (
    <INTERPRETATION id="polyamorous" className="polyamorous">
      {resultStringPolyamorous === ""
        ? ""
        : " I am " + resultStringPolyamorous + "."}
    </INTERPRETATION>
  );

  const text = result.map((item, index) => <div key={index}>{item}</div>);

  return (
    <div className="interpretation-container">
      {resultStringSelf !== "" && resultElementSelf}
      {resultStringBody !== "" && resultElementBody}
      {resultStringPronouns !== "" && resultElementPronouns}
      {(resultStringEmotional !== "" || resultStringPhysical !== "") &&
        resultElementEmotionalAndPhysical}
      {resultStringPolyamorous !== "" && resultElementPolyamorous}
    </div>
  );
};

export default Interpretation;
